import * as React from "react";
import Notification from "./Notification"
import globalStore from "../../stores/GlobalStore"
import * as styles from "../../../css/pages/mainlayout.css"

export default class NotificationBox extends React.Component<any, any> {

    constructor() {
        super(undefined); // TODO: undefined
        this.state = {
            notifications: []
        };
    }

    componentWillMount(){
        (globalStore as any).on("change", () => {
            this.setState({
                notifications: (globalStore as any).getNotifications()
            })
        })
    }

    componentWillUnmount(){
        (globalStore as any).removeAllListeners("change");
    }

    render() {

        let notificationComponents = this.state.notifications.map((notification) => {
            return <Notification key={notification.key} title={notification.title} message={notification.message}
                                 nType={notification.nType}></Notification>;
        });
        let notifications = <div className={styles.webcnotificationbox}>{notificationComponents}</div>;

        return(notifications);
    }
}
